import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { installViewportHeightFix } from './pwa/register';
import './index.css';

installViewportHeightFix();

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

// 設定 hydrate は App 内で行い、その間も ROM 起動と同じローダーを出す。
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
